import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
Vue.config.devtools = true

export const store = new Vuex.Store({
  state: {
    app_id: '',
    options: {
      url: '/vue/video/playlist'
    },
    app_data: {
      base_url: null,
      autoplay: false,
      loading: false
    },
    playlist: false,
    player: {
      ready: false,
      height: 0,
      selected: 0
    },
    restricted: false
  },
  mutations: {
    appID (state, str) {
      state.app_id = 'vvp-' + str
    },
    autoplay (state, bool) {
      state.app_data.autoplay = bool
    },
    loading (state, bool) {
      state.app_data.loading = bool
    },
    playlist (state, playlist) {
      state.playlist = playlist
    },
    selectVideo (state, index) {
      state.player.selected = index
    },
    playerHeight (state, height) {
      state.player.height = height
    },
    playerReady (state, bool) {
      state.player.ready = bool
    }
  },
  getters: {
    appID: state => state.app_id,
    loading: state => state.app_data.loading,
    player: state => state.player,
    playlist: state => state.playlist,
    url: state => state.options.url,
    autoplay: state => state.app_data.autoplay,
    selected: state => state.player.selected,
    currentVideo (state) {
      if (state.playlist !== false) {
        const obj = state.playlist.videos[state.player.selected]
        return (obj ? obj : false)
      } else {
        return false
      }
    }
  }
})
